import { Component, OnInit, ViewChild } from '@angular/core';
import { SapWarehoseService } from 'src/app/services/sap-warehose.service';
import { SapWarehouse } from 'src/app/models/sap-warehouse';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectorMatcher } from '@angular/compiler';

@Component({
  selector: 'app-warehouse-sap',
  templateUrl: './warehouse-sap.component.html',
  styleUrls: ['./warehouse-sap.component.css']
})
export class WharehouseSapComponent implements OnInit {
  loading:boolean = false;
  whSap:SapWarehouse[] = [];
  @ViewChild('sapWhModal') sapWhModal;

  constructor( private whSapServ:SapWarehoseService, private modal:NgbModal ) { }

  ngOnInit() {
    this.search();
  }

  search() {
    this.loading = true;
    this.whSapServ.getWarehouses()
      .then(resp => {
        this.whSap = resp;
        this.loading = false;
      }).catch(e => this.loading = false);
  }

  open() {
    this.modal.open(this.sapWhModal, {size: 'lg'});
  }
}
